import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import timezone from 'dayjs/plugin/timezone'
import UpdateLocale from 'dayjs/plugin/updateLocale'
import utc from 'dayjs/plugin/utc'

import { definePlugin } from '/@/app'

export default definePlugin(({ app }) => {
  app.use(() => {
    dayjs.extend(UpdateLocale)
    dayjs.extend(localeData)
    dayjs.extend(utc)
    dayjs.extend(timezone)
  })
})
